// extracted by mini-css-extract-plugin
module.exports = {"styles":"nYYoZ-hV1qlrLG1eRf3MF"};